import React from 'react';
import './styles.css';
import { AiOutlineAmazon } from "react-icons/ai";

const ListItem = ({
  item: { coverSrc, title, price, rating, link },
}) => (
  <div className='listItem-wrap'>
 <a href={link}>   <img src={coverSrc} alt='err' /></a>
    <header>
      <h4>{title}</h4>
      <span>⭐ {rating}</span>
    </header>
    <footer>
      <p>
        <b>${price}</b>
      </p>
      <a className="amazon" href={link}><AiOutlineAmazon /> View on Amazon</a>
    </footer>
  </div>
);

export default ListItem;

//{`${styles.description} ${styles.yellow}`}